module.exports = __webpack_public_path__ + "img/uniswap.849226c3.svg";